import { Link, useLocation } from "react-router-dom";
import { useSeo } from "@/hooks/useSeo";

export default function NotFound() {
  const location = useLocation();

  useSeo({
    title: "页面未找到 - 希岛爱理影视内容站",
    description: "抱歉，你访问的页面不存在或已被移除。返回首页继续浏览希岛爱理的影视作品、资讯与角色解析。",
    keywords: "页面未找到,404,希岛爱理影视内容站",
  });

  return (
    <div className="w-full px-4 md:px-8 py-24 flex flex-col items-center text-center">
      <span className="font-heading text-7xl md:text-9xl font-black text-background-200 select-none">
        404
      </span>
      <h1 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mt-4">
        页面未找到
      </h1>
      <p className="text-sm text-foreground-500 mt-2">
        你访问的地址 <span className="text-foreground-700 break-all">{location.pathname}</span> 不存在或已被移除。
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-home-4-line" />
          返回首页
        </Link>
        <Link
          to="/works"
          className="inline-flex items-center gap-1.5 px-4 py-2 rounded-md border border-background-200 text-foreground-800 text-sm hover:border-primary-300 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-film-line" />
          浏览影视作品
        </Link>
      </div>
    </div>
  );
}